<template>
  <div class="wrap">
    <head-nav :headType="headType"/>
    <router-view/>
    <foot-mol/>
    <div class="popup-mask" v-show="isShow" @click="showPop('close')"></div>
    <div class="popup" v-show="isShow">
      <p class="tt">扫描二维码，咨询详情</p>
      <!-- <img src="./assets/images/aboutUs/mol-3-1.png" class="pic"> -->
      <p class="tel">云资源热线：13651047008</p>
      <p>邮箱：chenjianyuan@nxin.com</p>
      <p>北京市海淀区中关村大街27号中关村大厦16层</p>
    </div>
  </div>
</template>

<script>
import HeadNav from './components/HeadNav.vue'
import FootMol from './components/FootMol.vue'

export default {
  components: {
    HeadNav,
    FootMol
  },
  data () {
    return {
      isShow: false
    }
  },
  mounted () {
  },
  provide () {
    return {
      ShowPop: this.showPop
    }
  },
  computed: {
    headType () {
      let meta = this.$route.meta || {};
      return meta.headType || ''
    }
  },
  methods: {
    showPop (type) {
      this.isShow = !(type === 'close')
    }
  }
}
</script>
